import axios from "axios";

const API = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
    baseURL: API,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            console.log("Token expired. Redirecting to login...");

            localStorage.clear();
            window.location.href = "/";
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;